import { Action } from "redux";

import { GET_INSURANCE_OFFER_REQUESTS } from "./types";

interface InsuranceOfferRequestAction extends Action {
  payload: any;
}

const initialState = {
  insuranceOfferRequests: [],
};

export default (state = initialState, action: InsuranceOfferRequestAction) => {
  switch (action.type) {
    case GET_INSURANCE_OFFER_REQUESTS:
      return {
        ...state,
        insuranceOfferRequests: action.payload,
      };
    default:
      return state;
  }
};
